// File: client/src/components/rules/nodeConfigs/SwitchConfig.js
import React from 'react';
import { Form, Radio, Input, Button, Divider, message } from 'antd';
import { PlusOutlined, MinusCircleOutlined } from '@ant-design/icons';
import MonacoEditor from 'react-monaco-editor';

const { TextArea } = Input;

// Editor options
const editorOptions = {
    minimap: { enabled: false },
    scrollBeyondLastLine: false,
    automaticLayout: true,
    fontSize: 14,
    lineNumbers: 'on',
    wordWrap: 'on',
};

const SwitchConfig = () => {
    const form = Form.useFormInstance();
    const configurationType = Form.useWatch('type', form) || 'javascript';

    return (
        <div>
            <Form.Item
                name="type"
                label="Configuration Type"
                rules={[{ required: true, message: 'Please select a configuration type' }]}
            >
                <Radio.Group>
                    <Radio.Button value="javascript">JavaScript</Radio.Button>
                    <Radio.Button value="field">Field</Radio.Button>
                    <Radio.Button value="ai">AI</Radio.Button>
                </Radio.Group>
            </Form.Item>

            {configurationType === 'javascript' && (
                <Form.Item
                    name="expression"
                    label="Expression"
                    tooltip="JavaScript expression that returns a value"
                    rules={[{ required: true, message: 'Please enter an expression' }]}
                >
                    <MonacoEditor
                        height="150"
                        language="javascript"
                        theme="vs-light"
                        options={editorOptions}
                        defaultValue="record.callType"
                    />
                </Form.Item>
            )}

            {configurationType === 'field' && (
                <Form.Item
                    name="field"
                    label="Field"
                    rules={[{ required: true, message: 'Please select a field' }]}
                >
                    <Input placeholder="Field name (e.g., callType)" />
                </Form.Item>
            )}

            {configurationType === 'ai' && (
                <Form.Item
                    name="prompt"
                    label="AI Prompt"
                    tooltip="Natural language prompt to categorize the call"
                    rules={[{ required: true, message: 'Please enter a prompt' }]}
                >
                    <TextArea
                        rows={4}
                        placeholder="e.g., Categorize this call as either 'complaint', 'inquiry', or 'feedback'"
                    />
                </Form.Item>
            )}

            <Divider>Output Options</Divider>

            <Form.List
                name="outputs"
                initialValue={['Option 1', 'Option 2', 'Default']}
            >
                {(fields, { add, remove }) => (
                    <>
                        {fields.map(({ key, name, ...restField }) => (
                            <Form.Item
                                key={key}
                                {...restField}
                                name={name}
                                style={{ marginBottom: 8 }}
                            >
                                <Input
                                    placeholder="Option name"
                                    addonAfter={
                                        <MinusCircleOutlined
                                            onClick={() => {
                                                if (fields.length > 1) {
                                                    remove(name);
                                                } else {
                                                    message.warn('At least one output option is required');
                                                }
                                            }}
                                        />
                                    }
                                />
                            </Form.Item>
                        ))}
                        <Form.Item>
                            <Button
                                type="dashed"
                                onClick={() => add()}
                                block
                                icon={<PlusOutlined />}
                            >
                                Add Option
                            </Button>
                        </Form.Item>
                    </>
                )}
            </Form.List>
        </div>
    );
};

export default SwitchConfig;
